import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import "./HeLanding.css";
import cardBg from './Assets/he-landing/pillar-card.svg';
import knowyourself from './Assets/he-landing/pillar-know-yourself.png';
import wheel from './Assets/he-landing/pillar-wheel.png';
import theexperts from './Assets/he-landing/pillar-experts.png';
import studio from './Assets/he-landing/pillar-studio.png';
import amu from './Assets/he-landing/pillar-amu.png';
import journeyBg from './Assets/he-landing/journey-bg.png';

// Static data — API calls are commented out below
const STATIC_TITLE = "Start Your Journey";
const STATIC_SUBTITLE =
  "Your destiny is more than a single reading — it’s an evolving journey. Explore five pillars of guidance, each designed to help you gain clarity, grow, and move forward with confidence.";

const STATIC_SERVICES = [
  {
    key: 'knowYourself',
    title: 'Know Yourself',
    desc: 'A space for insights across health, career, relationships, and more — updated daily, monthly, and yearly.',
    icon: knowyourself,
    route: '/chart',
  },
  {
    key: 'theWheel',
    title: 'The Wheel',
    desc: 'A modern ritual for reflection — offering symbolic insights to help you pause, consider, and move forward with clarity.',
    icon: wheel,
    route: '/fortune-stick',
  },
  {
    key: 'theExperts',
    title: 'The Experts',
    desc: 'Connecting you with experienced practitioners for personalised consultations — helping you explore your questions with greater clarity and confidence.',
    icon: theexperts,
    route: '/schedule',
  },
  {
    key: 'studio',
    title: 'Studio',
    desc: 'A range of courses and online classes designed to support your personal growth, learning, and self-development.',
    icon: studio,
    route: '/courses',
  },
  {
    key: 'amu',
    title: 'A-MU',
    desc: "Featuring thoughtfully designed digital pieces with symbolic elements — created to support clarity, balance, and different aspects of daily life.",
    icon: amu,
    route: '/shop',
  },
];

export default function OurServices() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [servicesTitle, setServicesTitle] = useState(STATIC_TITLE);
  const [servicesDescription, setServicesDescription] = useState(STATIC_SUBTITLE);
  const [services, setServices] = useState(STATIC_SERVICES);

  const [langId, setLangId] = useState(localStorage.getItem('languageId') || '2224');

  useEffect(() => {
    const handleStorageChange = () => setLangId(localStorage.getItem('languageId') || '2224');
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Fetch section title & description from API
  useEffect(() => {
    const custId = localStorage.getItem('userID') || '0';
    const langIdValue = langId;
    fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetSiteContent?Code=LZ8GO&CustId=${custId}&LangId=${langIdValue}`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data) && data[0]?.Description && data[0]?.Title) {
          setServicesDescription(data[0].Description);
          setServicesTitle(data[0].Title);
        }
      })
      .catch(err => console.error('Failed to fetch services description:', err));
  }, [langId]);

  // Fetch individual service cards from API
  useEffect(() => {
    const langIdValue = langId;
    const serviceCodes = ['IY8BD', 'J6MA3', 'G7RHI', 'DSMHA', 'IOECH'];
    Promise.all(
      serviceCodes.map(code =>
        fetch(`https://xianhefairy.com/LotusFairy_API/api/SiteContent/GetSiteContent?Code=${code}&LangId=${langIdValue}`)
          .then(res => res.json())
      )
    )
      .then(results => {
        const fetched = results.map((data, i) => {
          if (Array.isArray(data) && data[0]?.Title && data[0]?.Description) {
            return { ...STATIC_SERVICES[i], title: data[0].Title, desc: data[0].Description };
          }
          return null;
        }).filter(Boolean);
        if (fetched.length > 0) setServices(fetched);
      })
      .catch(err => console.error('Failed to fetch services data:', err));
  }, [langId]);

  return (
    <section className="he-section he-journey" id="our-services">
      <img className="he-section-bg" src={journeyBg} alt="" />
      <div className="he-intro">
        <div className="he-eyebrow">{t('mainPage.journeyEyebrow', 'THE WAY BEGINS WITHIN')}</div>
        <h2>{servicesTitle}</h2>
        <p>{servicesDescription}</p>
      </div>
      <div className="he-pillars">
        {services.map(service => (
          <button
            key={service.key}
            type="button"
            className="he-pillar"
            onClick={() => navigate(service.route)}
          >
            <img className="he-pillar-bg" src={cardBg} alt="" />
            <img className="he-pillar-icon" src={service.icon} alt="" />
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </button>
        ))}
      </div>
    </section>
  );
}
